import PropTypes from 'prop-types';
import React from 'react';
import Link from './Link';

/**
 * Display status message
 * Shows an icon [green check, error, warning, pending] based on type
 * followed by a line of text
 */
class StatusMessage extends React.PureComponent {
  static propTypes = {
    /**
     * Type of message
     */
    type: PropTypes.oneOf(['success', 'warning', 'error', 'pending']),

    /**
     * Message to be displayed
     */
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),

    /**
     * Link to redirect for click on the message
     * If both href and to values are set, href will be used
     */
    href: PropTypes.string,

    /**
     * Ignored if href is null
     * True indicates open in new tab, false opens in the same tab
     */
    newTab: PropTypes.bool,
    /**
     * Link to redirect within the app for click on the message
     */
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ pathname: PropTypes.string, query: PropTypes.object })]),

    /**
     * Optional className to be applied to the component
     */
    className: PropTypes.string,

    /**
     * Override with custom icon
     */
    overrideIcon: PropTypes.string,

    /**
     * Override classname for custom color for the icon
     */
    overrideIconColorClass: PropTypes.string,

    /**
     * Callback function for click
     */
    onClick: PropTypes.func,

    /**
     * Object for i13n tracking
     */
    i13nModel: PropTypes.object,

    /**
     * Used for testing
     */
    testid: PropTypes.string,
  };

  static defaultProps = {
    newTab: true,
    className: '',
  };

  render() {
    let icon, colorType;
    const { text, href, to, type, newTab, className, overrideIcon, overrideIconColorClass, onClick } = this.props;

    const testid = `status-message${this.props.testid ? `_${this.props.testid}` : ''}`;
    const i13nModel = Object.assign({ action: 'click', label: text }, this.props.i13nModel);

    switch (type) {
      case 'warning':
        icon = overrideIcon || type;
        colorType = overrideIconColorClass || 'h_c-warning';
        break;
      case 'error':
        icon = overrideIcon || type;
        colorType = overrideIconColorClass || 'h_c-error';
        break;
      case 'pending':
        icon = overrideIcon || 'watch_later';
        colorType = overrideIconColorClass || 'h_c-inactive';
        break;
      case 'success':
      default:
        icon = overrideIcon || 'check_circle';
        colorType = overrideIconColorClass || 'h_c-success';
    }

    return (
      <div className={`status_message ${className}`} onClick={onClick} data-testid={testid}>
        <i className={`material-icons status_message_icon ${colorType}`}>{icon}</i>
        <span className="text_container">
          {to ? (
            <Link to={to} i13nModel={i13nModel} testid={`${testid}-link`}>
              {text}
            </Link>
          ) : href ? (
            <Link href={href} newTab={newTab} i13nModel={i13nModel} testid={`${testid}-link`}>
              {text}
            </Link>
          ) : (
            text
          )}
        </span>
      </div>
    );
  }
}

export default StatusMessage;
